<template>
  <div>
    <el-table
        :data="formattedVideos"
        class="w100"
        stripe
    >
      <el-table-column label="Video Title" prop="video_title">
        <template slot-scope="props">
          <a
              :href="`https://youtube.com/watch?v=${props.row.video_id}`"
              target="_blank"
          >
            {{ props.row.video_title }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Video Id" prop="video_id"></el-table-column>
      <el-table-column label="Channel Id" prop="channel_id"></el-table-column>
      <el-table-column label="Asset Title" prop="title"></el-table-column>
      <el-table-column label="Asset ID" prop="track_id"></el-table-column>
      <el-table-column label="Label" prop="label_name"></el-table-column>
      <el-table-column label="Claimed" prop="claim">
        <template slot-scope="props">
          <el-tag
              v-if="!props.row.claim"
              type="danger"
          >
            No claim
          </el-tag>
          <el-tag v-else type="success">
            Yes claim
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Claim" prop="manual_claimed">
        <template slot-scope="props">
          <p
            v-if="props.row.claim && props.row.manual_claimed"
          >
            Manual
          </p>
          <p v-else-if="props.row.claim && !props.row.manual_claimed">
            Auto
          </p>
          <p v-else>
            /
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Claim status" prop="claim_status">
      </el-table-column>
      <el-table-column label="Status" prop="approved">
        <template slot-scope="props">
          <el-tag
              v-if="props.row.approved === 1"
              type="success"
          >
            Approved
          </el-tag>
          <el-tag
              v-else-if="props.row.approved == 2"
              type="warning"
          >
            Pending
          </el-tag>
          <el-tag v-else type="danger">
            Rejected
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Claimed by" prop="email"></el-table-column>
      <el-table-column label="Published date" prop="published_date"></el-table-column>
<!--      <el-table-column label="Views" prop="formattedViews"></el-table-column>
      <el-table-column label="Revenue" prop="formattedRevenue"></el-table-column>-->
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Reject" placement="right">
            <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                class="mt10"
                @click="openRejectModal(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @current-change="currentChange"
        :current-page.sync="manual_claims.current_page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="manual_claims.total"
    ></el-pagination>
    <!-- Reject Modal -->
    <el-dialog
        title="Reject Claim"
        :visible.sync="rejectModalVisible"
        width="30%"
    >
      <el-form :model="rejectForm">
        <el-form-item label="Reason for rejection">
          <el-input
              type="textarea"
              v-model="rejectForm.reason"
              placeholder="Enter rejection reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectModalVisible = false">Cancel</el-button>
        <el-button type="danger" @click="submitRejection">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import format from "date-fns/format";

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectForm: {
        claimId: null,
        reason: "",
      },
    };
  },
  computed: {
    ...mapState("channelVideoClaims", [
      "manual_claims",
      "loading",
      "order_column",
      "order_type",
    ]),

    formattedVideos() {
      return this.manual_claims && this.manual_claims.data
          ? this.manual_claims.data.map((video) => ({
            ...video,
            formattedViews: Number(video.total_views).toLocaleString('en-US'),
            formattedRevenue: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(video.total_revenue),
          }))
          : [];
    },
  },

  methods: {
    ...mapMutations("channelVideoClaims", ["setPage", "setOrdering"]),
    ...mapActions("channelVideoClaims", ["readManualClaims", "rejectClaim"]),
    currentChange(currentPage) {
      this.setPage(currentPage);
      this.readManualClaims();
    },
    shouldShowButton(item) {
      return item.claim === 0;
    },
    confirm(row) {
      this.$confirm('You will confirm this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => {
            this.confirmClaim(row.claimId)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Claim cancelled'
            })
          })
    },
    openRejectModal(row) {
      this.rejectForm.videoId = row.video_id;
      this.rejectForm.reason = "";
      this.rejectModalVisible = true;
    },

    async submitRejection() {
      if (!this.rejectForm.reason) {
        this.$message.error("Please provide a reason for rejection.");
        return;
      }

      try {
        await this.rejectClaim({
          videoId: this.rejectForm.videoId,
          reason: this.rejectForm.reason,
        });
        this.$message.success("Claim rejected successfully.");
        this.rejectModalVisible = false;
        this.readManualClaims();
      } catch (error) {
        console.error(error);
        this.$message.error("Failed to reject the claim.");
      }
    },
  },

  created() {
    this.readManualClaims();
  },
};
</script>